import axios from 'axios';

export default () => {
    return axios.create({
        // baseURL: `http://localhost:8088`
        // baseURL: `http://10.120.2.171:8088`
        // baseURL: `https://nmsapi.tornography.com`
        baseURL: process.env.VUE_APP_API_URL
    });
};
